export default {
  appRootUrl: process.env.REACT_APP_APP_ROOT_URL,
  type: process.env.NODE_ENV,
  version: process.env.REACT_APP_VERSION,
  api: {
    url: process.env.REACT_APP_API_URL,
    basePath: process.env.REACT_APP_API_BASE_PATH,
    track: process.env.REACT_APP_SUCCESS_SCREEN_URL,
    trackMonitoringsRequestsOutgoing: process.env.REACT_APP_SUCCESS_SCREEN_URL_MONITORINGS_REQUESTS_OUTGOING,
    co3Domain: process.env.REACT_APP_CO3_DOMAIN,
    timeout: 60 * 1000,
  },
  app: {
    domain: process.env.REACT_APP_CO3_DOMAIN,
  },
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    'auth-server-url': process.env.REACT_APP_KEYCLOAK_URL,
    'ssl-required': 'external',
    'public-client': true,
    init: {
      onLoad: 'check-sso',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      useNonce: true,
      enableLogging: process.env.REACT_APP_NODE_ENV !== 'production',
      redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URL,
    },
  },
  auth: {
    google: {
      clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
      scope: 'openid profile email',
    },
  },
};
